<template>
  <div :class="['body']">
    <div>
      <div class="questions-bg">
        <img class="bg" src="@a/measurement/questions_bg.png" alt="">
        <h2 class="title">个人能力测评</h2>
      </div>
      <!-- 测评答题组件 -->
      <div class="answer-questions">
        <!-- 选题模块 -->
        <div class="questions-container">

          <!-- 题目 -->
          <div >
            <div  class="questions-title">
              <ul >
                <li  class="title">很高兴你接受发送人的邀请，对TA以下各方面进行评价</li>
                <li  class="title">您的评价对TA很重要，客观的评价对TA的个人成长有更大帮助</li>
                <li  class="title">评价匿名且保密，请按照实际情况来选择</li>
              </ul>
            </div>
          </div>
          

        </div>
        
        <!-- 下一步 -->
        <div class="btn-group-on">
            <!-- @click="previousHandle()" -->
          <button class="previousBtn-on" @click="beginSheethandle()" >开始评价</button>
        </div>
        
      </div>
    </div>
    

  </div>
</template>

<script>

export default {
  data() {
    return {

    }
  },

  computed: {
    
  },
  methods: {
   beginSheethandle(){
        this.$emit("answerBoolhandle",false);
    }
  },
  created(){
    
  }
}
</script>

<style lang="scss" scoped>
.body{
  position: absolute;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: #E60012;
  z-index: 1;
}

.questions-bg{
  height: 360px;
  z-index: 2;
  img.bg{
    width: 100%;
    height: 360px;
    position:relative;
    z-index: 2;
  }
  h2.title{
    position: relative;
    z-index: 3;
    font-size: 60px;
    font-weight: bold;
    color: #ffffff;
    margin: -227px auto auto 57px;
  }
}




.answer-questions {
  margin-top: -95px;
  padding: 0px 30px 90px;
  text-align: center;
  position: relative;
  z-index: 3;
  // 弹出开始测评说明
  .answer-sheet {
    transition: all 2s;
    position: fixed;
    z-index: 998;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    max-width: 750px;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .answer-sheet.on {
    left: -750px;
  }
  .questions-container {
    box-shadow: 0px 1px 8px 2px rgba(235, 80, 50, 0.14);
    border-radius: 10px;
    padding: 35px 30px;
    background-color: #ffffff;
    // min-height: 800px;
    position: relative;
    .questions-title {
      color: #333333;
      text-align: left;
      .title {
        font-size: 30px;
        font-weight: bold;
        line-height:42px;
        margin: 40px auto;
        text-align: justify;
      }
      
    }

  }
  
  .btn-group-on{
    margin:70px auto 0;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    .previousBtn-on {
      line-height: 80px;
      height: 80px;
      color: #333333;
      background: #ffffff;
      border: 2px solid #eb5032;
      width: 260px;
      font-size: 32px;
      border-radius: 40px;
    }
  }

}

</style> 